import { equippedWeaponPropertyMatches } from '../compile/equipped-weapon-property';
import { readInventoryField } from '../compile/inventory-raw-readers';
import { THROW_HAND_SLOTS } from './throw-object-gate';

type Row = Record<string, unknown>;
export const WEAPON_PROPERTY_ACTIVATION = 'if_weapon_has_property_equipped_active';
type Readers = { value: (row: Row, key: string) => unknown; entries: (row: Row, key: string) => unknown[];
    definition?: (id: string) => Row | null };

/** A fragment is gated against this strike, including an other-hand rider. No missing definition becomes a false gate. */
export function weaponPropertyActivation(definition: Row, weapon: Row, read: Readers): true | false | string {
    const properties = read.entries(definition, WEAPON_PROPERTY_ACTIVATION);
    if (!properties.length) return true;
    const id = String(readInventoryField(weapon, 'inventory_item_id') ?? '');
    const held = weapon.item_layer_types ? weapon : read.definition?.(id) ?? null;
    let unknown: string | null = null;
    for (const property of properties) {
        if (typeof property !== 'string' || !property) { unknown = 'unreadable'; continue; }
        if (!held?.item_layer_types) { unknown = property; continue; }
        if (equippedWeaponPropertyMatches(weapon, property, {
            layerValue: (row, key) => read.value(row as Row, key) ?? read.value(held, key),
            layerEntries: (row, key) => read.entries(row as Row, key).length ? read.entries(row as Row, key) : read.entries(held, key),
        }, THROW_HAND_SLOTS)) return true;
    }
    return unknown ? `extra-damage-weapon-property-not-held:${unknown}` : false;
}
